<script setup>
import { useDetectDevice } from '@/composables/device'

import WarehouseAvailabilityMobile from '@/components/planner/WarehouseAvailabilityMobile.vue'
import WarehouseAvailabilityTimeline from '@/components/planner/WarehouseAvailabilityTimeline.vue'

const { isMobile } = useDetectDevice()
</script>

<template>
  <warehouse-availability-mobile v-if="isMobile" />
  <warehouse-availability-timeline v-else />
</template>
